/**
 * Dependencies.
 */
import { AxiosRequestConfig } from 'axios';

/**
 * Export `partnershipIdRequestInterceptor`.
 */
export const partnershipIdRequestInterceptor = (
  config: AxiosRequestConfig
): AxiosRequestConfig => {
  const { headers, url } = config || {};

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const partnershipId = urlParams.get('partnershipId');

  if (partnershipId && url.includes('social-network')) {
    const partnershipHeader = { 'X-Partnership-Id': partnershipId };

    config = {
      ...config,
      headers: {
        ...headers,
        ...partnershipHeader
      }
    };
  }

  return config;
};
